import React from 'react';
import { useAuth } from '../context/AuthContext';
import PublicHeader from './PublicHeader';

const PublicLayout = ({ children, showHeader = true }) => {
  const { user } = useAuth();
  
  // Afficher le header uniquement si l'utilisateur est connecté
  const shouldShowHeader = showHeader && user;
  
  return (
    <div className="min-h-screen bg-white">
      {shouldShowHeader && <PublicHeader />}
      <main className="bg-[#F7F5F2]">
        {children}
      </main>
    </div>
  );
};

export default PublicLayout;
